import * as React from "react";
import { HRQuestionId, HRQuestionTemplateId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion, GeneralSignatureAnswer } from "../../messages/HR";
import { GenericInputHeader } from "./GenericInputHeader";
import { GenericSignatureInput } from "./GenericSignatureInput";

interface GenericGeneralSignatureProps {
    hrGeneralSignatureQuestionWithStatus: HRQuestionWithStatus<HRQuestion.GeneralSignatureQuestion>;
    isHidden: boolean;
    onChange: (newVal: GeneralSignatureAnswer, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericGeneralSignature extends React.Component<GenericGeneralSignatureProps> {
    constructor(props: GenericGeneralSignatureProps) {
        super(props);
    }

    render() {
        const generalSignaturePerson = this.props.hrGeneralSignatureQuestionWithStatus.question.answer === null ?
        "" : this.props.hrGeneralSignatureQuestionWithStatus.question.answer.generalSignaturePerson === null ?
        "" : this.props.hrGeneralSignatureQuestionWithStatus.question.answer.generalSignaturePerson;
        const signature = this.props.hrGeneralSignatureQuestionWithStatus.question.answer === null ?
        null : this.props.hrGeneralSignatureQuestionWithStatus.question.answer.signature;
        return (
            <div>
                { this.props.hrGeneralSignatureQuestionWithStatus.question.isHidden ? null :
                    <div>
                        <div style={{ marginBottom: 16 }}>
                            <GenericInputHeader status={null} questionText={this.props.hrGeneralSignatureQuestionWithStatus.question.questionText} />
                            <input
                                required={this.props.hrGeneralSignatureQuestionWithStatus.question.isMandatory}
                                id={HRQuestionTemplateId.unwrap(this.props.hrGeneralSignatureQuestionWithStatus.question.textId)}
                                className={"form-control"}
                                onChange={(newVal: any) => this.props.onChange({
                                    signature: signature,
                                    generalSignaturePerson: newVal === null ? null : newVal.target.value
                                }, this.props.hrGeneralSignatureQuestionWithStatus.question.id)}
                                placeholder={"Enter here signature person name..."}
                                value={generalSignaturePerson}
                                onBlur={() => this.props.onBlur(this.props.hrGeneralSignatureQuestionWithStatus.question.id)}
                            />
                        </div>
                        <GenericSignatureInput
                            key={HRQuestionId.unwrap(this.props.hrGeneralSignatureQuestionWithStatus.question.id)}
                            hrSignatureQuestionWithStatus={{
                                question: this.props.hrGeneralSignatureQuestionWithStatus.question,
                                status: this.props.hrGeneralSignatureQuestionWithStatus.status
                            }}
                            isHidden={false}
                            onChange={(newVal) => this.props.onChange({
                                signature: newVal,
                                generalSignaturePerson: generalSignaturePerson
                            }, this.props.hrGeneralSignatureQuestionWithStatus.question.id)}
                            onBlur={(id) => this.props.onBlur(id)}
                        />
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericGeneralSignature.tsx